export default __webpack_public_path__ + "static/media/Opificio-Regular.b8c75bbe.ttf";